import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect, useCallback } from "react";
import wp from "wp";
const CodeMirror = (param)=>{
    let { settings = {}, value = "", onChange } = param;
    const ref = useRef();
    const codeMirrorRef = useRef();
    const { codeEditor } = wp;
    useEffect(()=>{
        // Check if the current profile allows syntax highlighting
        if (codeEditor) {
            const { codemirror } = codeEditor.initialize(ref.current, settings);
            codeMirrorRef.current = codemirror;
            codemirror.on("change", (instance)=>{
                onChange == null ? void 0 : onChange(instance.getValue());
            });
        }
    }, []);
    // Avoid React error: You provided a `value` prop to a form field without an `onChange` handler
    // The onChange handler is done by codemirror itself
    const noop = useCallback(()=>{
    // Silence is golden.
    }, []);
    // Fix values coming from controlled element (e.g. antd `<Form.Item`)
    useEffect(()=>{
        if (typeof value === "string" && ref.current && codeMirrorRef.current && ref.current.value !== codeMirrorRef.current.getValue()) {
            codeMirrorRef.current.setValue(ref.current.value);
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ _jsx("textarea", {
        ref: ref,
        value: value,
        onChange: codeEditor ? noop : (param)=>{
            let { target: { value } } = param;
            return onChange(value);
        },
        style: {
            width: "100%"
        }
    });
};
export { CodeMirror };
